import React from "react";
import styles from "./QuickLaunch.module.css";
import { PromptStage } from "../configuration-tab/components";

const promptModels = [
	{
		value: 1,
		subTitle:
			"This is model for Juridique note creation. It will extract information that is related to Juridique topic",
		title: "Juridique",
	},
	{
		title: "Financier",
		subTitle:
			"This is model for Financier note creation. It will extract information that is related to Financier topic",
		value: 2,
	},
	{
		title: "Prix",
		subTitle: "This is model for Prix note creation. It will extract information that is related to Prix topic",
		value: 3,
	},
];
const QuickLaunchTab = ({ onChangeQuickLaunchInstructions, quickLaunchSelection }) => (
	<div className={styles.container}>
		<PromptStage
			isMultiSelect
			promptModels={promptModels}
			promptModelsTitle="Modèles de notes"
			selection={quickLaunchSelection}
			onChangeInstructions={onChangeQuickLaunchInstructions}
		/>
	</div>
);

export default QuickLaunchTab;
